module.exports = __webpack_public_path__ + "static/scale-model-of-ecohouse-in-berkeley-california-1a4a3cb36afb47d5d48370d8178b4662.png";